<mat-card class="cal-card">
  <mat-card-content>
    <div class="cal-header">
      <button
        mat-icon-button
        class="cal-nav"
        (click)="prevMonth()"
        aria-label="Previous month"
        data-testid="calendar-widget-prev-btn"
      >
        <mat-icon aria-hidden="true">chevron_left</mat-icon>
      </button>
      <span
        class="cal-month"
        aria-live="polite"
        aria-atomic="true"
        data-testid="calendar-widget-month-label"
        >{{ monthLabel }}</span
      >
      <button
        mat-icon-button
        class="cal-nav"
        (click)="nextMonth()"
        aria-label="Next month"
        data-testid="calendar-widget-next-btn"
      >
        <mat-icon aria-hidden="true">chevron_right</mat-icon>
      </button>
    </div>

    <div class="cal-grid" role="grid" aria-label="Calendar">
      @for (
        d of ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        track $index
      ) {
        <div class="cal-day-label" role="columnheader" aria-label="{{ d }}">
          {{ d.charAt(0) }}
        </div>
      }
      @for (day of days; track $index) {
        <div
          class="cal-day"
          role="gridcell"
          [class.today]="isToday(day)"
          [class.empty]="!day"
          [attr.aria-label]="
            day
              ? isToday(day)
                ? monthLabel + ' ' + day + ', today'
                : monthLabel + ' ' + day
              : null
          "
          [attr.aria-current]="isToday(day) ? 'date' : null"
          [attr.aria-disabled]="!day ? 'true' : null"
        >
          {{ day ?? '' }}
        </div>
      }
    </div>
  </mat-card-content>
</mat-card>
